import React, { useEffect, useState } from "react";
import "./Icons.css";
//import "./Footer.css";
//import Category from "./Category";
//import HorizontalFooter from "./HorizontalFooter";

const Icons = function (props) {
    const [currItems,setCurrItems]= useState([]);
    const [categoryArray,setCategoryArray]= useState([]);
    useEffect(()=>{
        if(!!props.items && props.items.length>0){        
            let baseUrl =window.location.origin;
            let items = props.items.map((item,idx)=>{
                
                let tempUrl='';
               let column_display= !!item.MatalLogoPosition && item.MatalLogoPosition=='מעל' ? '':'';
                if(!!item.MatalLogo && !!item.MatalLogo.ImageUrl){                  
                   tempUrl = baseUrl+item.MatalLogo.ImageUrl;
                }
                
                return (<div key={item.ID} className={'col-lg-3 icon-item ' +column_display}>
                          {!!tempUrl ?  <img className='img-link-icon' src={tempUrl} alt=""/>:false}
                            <div className='icon-item-text'> {item.MatalLogoText}</div>
                        </div>);
            });
            setCurrItems(items);
        }
    },[props.items]);
 
    return (
        <div className="col-12 col-lg-12 wp-icons">           
            <div className={'icon-title'}>
                <h2 className="wp-title col-12 col-lg-10" role="heading" aria-level="2">{props.title} </h2>
             </div>
            <div className={'icon-items'}>
                 {currItems}</div>
        </div>
    );
}
export default Icons;